export default Object.freeze({
	DeliveredDate: 'delivered_date',
	ShipDate: 'ship_date',
	TransactionDate: 'transaction_date',
});
